import styled, { StyledComponentProps } from 'styled-components'
import { cssMediaQueryBreakpoints } from '../config/breakpoints'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {
    height: number
    width: number
    smallHeight: number
    smallWidth: number
}

export const PauseStandardIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10 7V24" strokeWidth="4" strokeLinecap="round" />
            <path d="M22 7V24" strokeWidth="4" strokeLinecap="round" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    ${cssMediaQueryBreakpoints.small} {
        height: ${p => p.smallHeight}px;
        min-height: ${p => p.smallHeight}px;
        width: ${p => p.smallWidth}px;
        min-width: ${p => p.smallWidth}px;
        margin-right: 4px;
    }

    height: ${p => p.height}px;
    min-height: ${p => p.height}px;
    width: ${p => p.width}px;
    min-width: ${p => p.width}px;
    margin-right: 8px;
    cursor: pointer;

    stroke: ${p => p.theme.playColor};
`
